// Header
window.addEventListener('scroll', ()=>{
    const header = document.querySelector('header');
    header.classList.toggle('sticky',window.scrollY > 0);
})

// View card
window.addEventListener('scroll',reveal);

function reveal(){
    let reveals = document.querySelectorAll('.reveal');

    for(let i = 0; i < reveals.length; i++){
        let windowheight = window.innerHeight;
        let revealtop = reveals[i].getBoundingClientRect().top;
        let revealpoint = 150;

        if(revealtop < windowheight - revealpoint){
            reveals[i].classList.add('active');
        } else {
            reveals[i].classList.remove('active');
        }
    }
}

// scroll
window.addEventListener('scroll', ()=>{
    const topBtn = document.getElementById('top-btn');
    topBtn.classList.toggle('active',window.scrollY > 20);
})